function lower(value) {
    return value == null ? value : value.toLowerCase();
}
export function findAuthorizedId(firstName, lastName, authNames) {
    if (authNames.length === 0) {
        return -1;
    }
    const lowerFirst = lower(firstName);
    const lowerLast = lower(lastName);
    for (const authName of authNames) {
        if (lower(authName.firstName) === lowerFirst && lower(authName.lastName) === lowerLast) {
            return authName.id;
        }
    }
    return null;
}



// WEBPACK FOOTER //
// ./src/assets/scripts/domain/validation/utils.ts